'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var componentWithName = {};

exports.__exports = componentWithName;
